import { createContext } from "react";
import AuthStore from "../store/AuthStore";

interface AuthState {
    authStore: AuthStore;
}

export const AuthContext = createContext(null);